import { cloneDeep } from "lodash";
/** 处理新增时候的表单数据 */
export const handleAddFormData = (data, channelInfo) => {
  const params = cloneDeep(data);
  console.log("🚀 ~ handleAddFormData ~ params:", params);
  /** 配置类型属于渠道 */
  if (params.appType === "1") {
    /** 如果配置渠道是全部渠道的时候 */
    if (params.channel.type === "0") {
      /** 渠道列表里面的数据 也要与之对应 */
      params.channel.channelInfoList[0].channelId = "0";
      params.channel.channelInfoList[0].channelName = "全部渠道";
      /** 如果终端选择了两个终端 */
      if (params.channel.channelInfoList[0].terminalType.length === 2) {
        const terminalTypeList = params.channel.channelInfoList[0].terminalType;
        params.channel.channelInfoList[0].terminalType = terminalTypeList[0];
        params.channel.channelInfoList.push({
          channelId: "0",
          channelName: "全部渠道"
        });
        params.channel.channelInfoList[1].terminalType = terminalTypeList[1];
      } else {
        params.channel.channelInfoList[0].terminalType =
          params.channel.channelInfoList[0].terminalType[0];
      }
    } else if (params.channel.type === "1") {
      /** 如果配置渠道是指定渠道的时候， 用channelInfo里的数据进行组装 */
      const newChannelInfoList = [];
      for (let index = 0; index < channelInfo.channelId.length; index++) {
        const newChannelInfo = {
          channelId: channelInfo.channelId[index],
          channelName: channelInfo.channelName[index],
          terminalType: channelInfo.terminalType[index]
        };
        newChannelInfoList.push(newChannelInfo);
      }
      params.channel.channelInfoList = newChannelInfoList;
    }
    delete params.platform;
  }
  /** 配置类型是平台 */
  if (params.appType === "2") {
    delete params.channel;
  }
  return params;
};

/** 处理编辑时回填的表单数据 */
export const handleEditFormData = data => {
  const params = cloneDeep(data);
  params.id = data.id;
  params.channel = {
    // 渠道数据
    // 渠道配置类型: 0全部渠道 1指定渠道
    type: "0",
    // 渠道明细列表
    channelInfoList: [
      {
        // 每个渠道的终端类型: 1发送端 2接收端
        terminalType: [],
        // 渠道名称
        channelName: "",
        // 渠道id，0表示全部渠道
        channelId: ""
      }
    ]
  };
  params.platform = {
    // 定制类型: 1-SDK 2-APP
    customizedTypeList: [],
    // key为终端类型: 1发送端 2接收端，value为平台列表：Android、IOS、Windows、MAC、Linux、web、weixin、cloudApp
    platformMap: {
      "1": [],
      "2": []
    }
  };
  const channelInfo = {
    channelId: [],
    channelInfo: {
      channelId: [],
      channelName: [],
      terminalType: []
    },
    showPopups: false
  };
  // 插件ID
  params.pluginId = data.appPlugin.id;
  // 策略名称
  params.name = data.name;
  // 加载方式
  params.loadType = String(data.loadType);
  // 优先级
  params.priority = data.priority;
  // 配置类型
  params.appType = String(data.appType);
  // 配置渠道
  params.channel.type = data.channel.type;

  // 厂商
  params.manufacturer = data.manufacturer;
  // 品牌
  params.brand = data.brand;
  // 型号
  params.model = data.model;
  // UID
  params.uid = data.uid;
  // UUID
  params.uuid = data.uuid;
  /** 配置类型属于渠道 */
  if (String(data.appType) === "1") {
    /** 如果配置渠道是全部渠道的时候 */
    if (data.channel.type === "0") {
      /** 如果终端选择了两个终端 */
      if (data.channel.channelInfoList.length === 2) {
        // 两个终端，转为数组
        params.channel.channelInfoList[0].terminalType = data.channel.channelInfoList.map(
          item => {
            return item.terminalType;
          }
        );
      } else {
        // 单个终端，转为数组
        params.channel.channelInfoList[0].terminalType = [
          data.channel.channelInfoList[0].terminalType
        ];
      }
    } else if (data.channel.type === "1") {
      // 指定渠道，处理渠道选择组件所需要的数据
      data.channel.channelInfoList.forEach(item => {
        channelInfo.channelId.push(item.channelId);
        channelInfo.channelInfo.channelId.push(item.channelId);
        channelInfo.channelInfo.channelName.push(item.channelName);
        channelInfo.channelInfo.terminalType.push(item.terminalType);
      });
      channelInfo.channelId = channelInfo.channelId.join(",");
      params.channel.channelInfoList[0].channelName = channelInfo.channelInfo.channelName.join(
        ","
      );
    }
  }
  /** 配置类型属于平台 */
  if (String(data.appType) === "2") {
    params.platform.customizedTypeList = data.platform.customizedTypeList;
    if (data.platform.platformMap[1]) {
      params.platform.platformMap["1"] = data.platform.platformMap[1];
    }
    if (data.platform.platformMap[2]) {
      params.platform.platformMap["2"] = data.platform.platformMap[2];
    }
  }
  return { params, channelInfo };
};
